import {NgModule} from '@angular/core';
import {ActionComponent} from './action/action.component';
import {ActionsComponent} from './actions.component';
import {IconActionComponent} from './action/icon-action/icon-action.component';
import {PrimaryIconActionComponent} from './action/icon-action/primary-icon-action/primary-icon-action.component';
import {SubmitActionComponent} from './action/submit-action/submit-action.component';
import {LinkActionComponent} from './action/link-action/link-action.component';
import {CommonModule} from '@angular/common';
import {IconsModule} from '../icons/icons.module';

@NgModule({
    declarations: [
        ActionComponent,
        ActionsComponent,
        IconActionComponent,
        PrimaryIconActionComponent,
        SubmitActionComponent,
        LinkActionComponent
    ],
    entryComponents: [
    ],
    exports: [
        ActionComponent,
        ActionsComponent,
        IconActionComponent,
        PrimaryIconActionComponent,
        SubmitActionComponent,
        LinkActionComponent
    ],
    imports: [
        IconsModule,
        CommonModule
    ]
})
export class ActionsModule {
}
